import { Location } from "@angular/common";
import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { fadeSlideInUp } from "../../ui-animations";
import { LoanDashboardService } from "src/app/loan-layout/components/loan-dashboard/loan-dashboard.service";
import { screenContent } from "../../constant/content";

@Component({
    selector: "web-info-error",
    templateUrl: "./info-error.component.html",
    styleUrls: ["./info-error.component.scss"],
    animations: [fadeSlideInUp],
})
export class InfoErrorComponent {
    icon = "assets/svg/icons/eye-gs.svg";
    title = "";
    description = "";
    isInnerHtml = false;
    rightButtonName = "Continue Anyways";
    leftButtonName = "Back";
    rightButtonRoute = "";
    leftButtonRoute = "";
    rightButtonRouteState: { [key: string]: any } = {};
    leftButtonRouteState: { [key: string]: any } = {};
    rightButtonIcon = "";

    retryAfterTitle = "but you can try again in...";
    retryAfter = 0;
    retryAfterRoute = "";
    retryAfterButtonName = "Retry Now...";
    counter = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    };

    timeinterval: any;
    timeLeft = 0;

    redirectInterval: any;
    redirectCountdown = 0;
    redirect = 0;
    redirectRoute = "";

    isBrandLogoVisible: boolean = false;

    navEntries = true;

    constructor(
        private router: Router,
        private location: Location,
        private sanitizer: DomSanitizer,
        private loanDashboardService: LoanDashboardService
    ) {
        let navState = history.state as any | undefined;
        if (navState && Object.keys(navState).length > 0) {
            if (navState.template) {
                navState = screenContent[navState.template];
            }

            this.isBrandLogoVisible = navState?.isBrandLogoVisible ?? false;

            this.icon = navState?.icon ? navState?.icon : this.icon;
            this.title = navState?.title ? navState?.title : this.title;
            this.description = navState?.description ? navState?.description : this.description;
            this.rightButtonName = navState?.rightButtonName ? navState?.rightButtonName : this.rightButtonName;
            this.rightButtonIcon = navState?.rightButtonIcon ? navState?.rightButtonIcon : this.rightButtonIcon;
            this.leftButtonName = navState?.leftButtonName ? navState?.leftButtonName : this.leftButtonName;
            this.rightButtonRoute = navState?.rightButtonRoute ? navState?.rightButtonRoute : this.rightButtonRoute;
            this.leftButtonRoute = navState?.leftButtonRoute ? navState?.leftButtonRoute : this.leftButtonRoute;
            this.rightButtonRouteState =
                Object.keys(navState?.rightButtonRouteState || {}).length > 0 ? navState?.rightButtonRouteState : {};
            this.leftButtonRouteState =
                Object.keys(navState?.leftButtonRouteState || {}).length > 0 ? navState?.leftButtonRouteState : {};
            this.isInnerHtml = navState?.isInnerHtml ? navState?.isInnerHtml : false;
            this.navEntries = navState?.navEntries == false ? navState?.navEntries : true;
            if (this.isInnerHtml && this.description) {
                this.description = this.sanitizer.bypassSecurityTrustHtml(this.description) as string;
            }

            // Timer
            if (navState?.retryAfter && navState?.retryAfter > 0) {
                this.retryAfterTitle = navState?.retryAfterTitle ? navState?.retryAfterTitle : this.retryAfterTitle;
                this.retryAfterRoute = navState?.retryAfterRoute ? navState?.retryAfterRoute : this.retryAfterRoute;
                this.retryAfter = navState?.retryAfter;
                this.timeLeft = navState?.retryAfter * 60;
                this.startTimer();
            }

            // Redirect
            if (navState?.redirect && navState?.redirectRoute) {
                this.redirect = navState?.redirect ? navState?.redirect : this.redirect;
                this.redirectRoute = navState?.redirectRoute ? navState?.redirectRoute : this.redirectRoute;
                this.startRedirectCountdown(this.redirect);
            }
        } else {
            this.location.back();
        }
    }

    ngOnInit() {
        if (this.navEntries) {
            const [navEntry] = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];

            if (navEntry?.type !== "reload") {
                return;
            }

            // Only bounce to home when *this* page is the one that was reloaded. Without the
            // path check a reload anywhere earlier in the session still counts as "reload" and
            // kicks the user out the moment they later navigate to an info/error screen.
            const reloadedPath = new URL(navEntry.name, window.location.origin).pathname;
            if (reloadedPath === window.location.pathname) {
                this.reload();
            }
        }
    }

    reload(): void {
        window.location.href = window.location.origin;
    }

    startTimer() {
        if (this.timeinterval) {
            clearInterval(this.timeinterval);
        }

        this.timeinterval = setInterval(() => {
            if (this.timeLeft > 0) {
                this.getTimeLeftMinutes();
                this.timeLeft--;
            } else {
                clearInterval(this.timeinterval);
            }
        }, 1000);
    }

    getTimeLeftMinutes(): void {
        let totalSeconds = this.timeLeft;

        const days = Math.floor(totalSeconds / 86400);
        totalSeconds %= 86400;

        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;

        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        this.counter = {
            days,
            hours,
            minutes,
            seconds,
        };
    }
    continue() {
        if (this.rightButtonRoute == "reload") {
            this.reload();
            return;
        }

        this.navigateTo(this.rightButtonRoute, this.rightButtonRouteState);
    }

    back() {
        this.navigateTo(this.leftButtonRoute, this.leftButtonRouteState);
    }

    retryAfterContinue() {
        this.navigateTo(this.retryAfterRoute);
    }

    startRedirectCountdown(count: number) {
        this.redirectCountdown = count;

        this.redirectInterval = setInterval(() => {
            this.redirectCountdown--;

            if (this.redirectCountdown === 0) {
                clearInterval(this.redirectInterval);
                this.navigateTo(this.redirectRoute);
            }
        }, 1000);
    }

    navigateTo(router: string, state = {}) {
        if (router == "/loan/timeline") {
            this.loanDashboardService.getDashboardDetails();
        } else {
            this.router.navigate([router], {
                state: state,
            });
        }
    }
}
